import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'global.css'
import { BrowserRouter as Router } from 'react-router-dom'
import SnackContextProvider from 'contexts/SnackContextProvider'
import CustomSnackBar from 'components/CustomSnackBar'
import LoadingContextProvider from 'contexts/LoadingContextProvider'
import CustomLoadingProcess from 'components/CustomLoadingProcess'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <LoadingContextProvider>
      <SnackContextProvider>
        <Router>
          <App />
          <CustomSnackBar />
          <CustomLoadingProcess />
        </Router>
      </SnackContextProvider>
    </LoadingContextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
